module.exports = __webpack_public_path__ + "static/abstract04-615699f88d7e8dfb9cd77f207ec7ca2e.jpg";